import { useDispatch, useSelector } from 'react-redux';
import { Link } from "react-router-dom";

import { usePageTitle } from 'utils/pageTitle';
import { removeItemFromCart } from 'reducers/cartReducer';

import './CartPage.css';


const CartPage = (props) => {
	usePageTitle('Cart');
	const dispatch = useDispatch();
	const {
		cartItems,
	} = useSelector(state => ({
		cartItems: state.cart.items,
	}));

	const onRemove = (address, documentName, extra) => {
		dispatch(removeItemFromCart(address, documentName, extra));
	}

	const itemCount = cartItems?.length || 0;

	return (
		<div className="cart-page">
			<div className="cart-page-inner">
				<div className="cart-page-header">
					<h1 className="cart-page-title">Cart</h1>
					{itemCount > 0 && (
						<span className="cart-page-count">
							{itemCount} {itemCount === 1 ? 'document' : 'documents'}
						</span>
					)}
				</div>

				{!itemCount ? (
					<div className="cart-card cart-empty">
						<div className="cart-empty-icon">
							<i className="bi bi-cart3" />
						</div>
						<h2 className="cart-empty-title">Your cart is empty</h2>
						<p className="cart-empty-text">
							Request documents from a property&apos;s Documents tab or its violation and
							permit records, and they&apos;ll show up here.
						</p>
						<Link to="/" className="cart-btn cart-btn-secondary">
							Find a property
						</Link>
					</div>
				) : (
					<div className="cart-layout">
						<div className="cart-items">
							{cartItems.map(item => (
								<div key={item.cartItemId} className="cart-card cart-item-row">
									<div className="cart-item-icon">
										<i className="bi bi-file-earmark-text" />
									</div>
									<div className="cart-item-details">
										<div className="cart-item-name">{item.documentName}</div>
										{item.extra && <div className="cart-item-extra">{item.extra}</div>}
										<Link className="cart-item-address" to={`/property/${item.address}/overview`}>
											{item.address}
										</Link>
									</div>
									<button
										className="cart-btn cart-btn-danger cart-btn-sm"
										onClick={() => onRemove(item.address, item.documentName, item.extra)}
										aria-label={`Remove ${item.documentName}`}
									>
										Remove
									</button>
								</div>
							))}
						</div>

						<aside className="cart-card cart-summary">
							<h2 className="cart-summary-title">Summary</h2>
							<div className="cart-summary-row">
								<span>Documents</span>
								<span>{itemCount}</span>
							</div>
							<p className="cart-summary-note">
								Violerts will contact you by email to deliver the requested documents.
								Each document request may have a fee, which will be disclosed by email
								upon request.
							</p>
							<Link to="/checkout" className="cart-btn cart-btn-primary cart-btn-block">
								Checkout
							</Link>
						</aside>
					</div>
				)}
			</div>
		</div>
	);
}

export default CartPage;
